<template>
  <el-dialog title="修改工作状态" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="changeform" :model="changeform" :label-width="formLabelWidth">
      <h3>1.技师上下线状态</h3>
      <el-form-item label="技师上下线状态" :label-width="formLabelWidth">
        <el-radio-group v-model="changeform.is_status">
          <el-radio :label="2">上线</el-radio>
          <el-radio :label="1">下线</el-radio>
        </el-radio-group>
      </el-form-item>
      <h3>1.技师上线时间</h3>
      <el-form-item label="开始时间">
        <el-time-select v-model="changeform.start_time" :picker-options="{ start: '00:00', step: '00:10', end: '23:59' }"
          placeholder="选择时间"></el-time-select>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-time-select v-model="changeform.end_time" :picker-options="{ start: '00:00', step: '00:10', end: '23:59' }"
          placeholder="选择时间"></el-time-select>
      </el-form-item>
      <h4>温馨提示：蓝色选中为上班时间</h4>
      <el-form-item label="" :label-width="formLabelWidth">
        <el-checkbox-group v-model="week">
          <el-checkbox-button v-for="(item,index) in weekList" :label="item.title" :key="index" border >{{ item.name }}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      changeform: {
        waiter_user_id: "", // 技师ID
        is_status: 2,
        work_time_id: '',
        start_time: '', // 上线时间
        end_time: '', // 下线时间
        week: '', // 周几
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      week: [],
      weekList: []
    };
  },
  props: ["open_working", "form"],
  created() {
    console.log(this.form, this.open_working);
    this.dialogVisible = this.open_working;
    this.changeform.waiter_user_id = this.form.waiterUserId;
    this.getWorkTime(this.form.waiterUserId)
  },
  methods: {
    getWorkTime(id) {
      let self = this;
      self.loading = true;
      Technician.getWorkTime({
        id:id
      }, true)
        .then(data => {
          self.loading = false;
          console.log(data);
          self.changeform.start_time = data.data.start_time
          self.changeform.end_time = data.data.end_time;
          self.changeform.is_status = data.data.is_status
          self.changeform.work_time_id =data.data.work_time_id
          self.weekList = data.data.week
          data.data.week.forEach(item => {
            if (item.active == '1') {
              self.week.push(item.title)
            }
          })
        })
        .catch(error => {
          self.loading = false;
        });
    },
    onSubmit() {
      let self = this;
      self.changeform.week = self.week.join(",");
      self.loading = true;
      Technician.postWorkTime(self.changeform, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，修改成功",
            type: "success"
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
  .el-checkbox-button {
    margin-right: 10px !important;
  }
  .el-checkbox-button__inner{
    border: 1px solid !important;
    border-radius: 15% !important;
  }
  .is-checked{
    border: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/dialog/changeworking.vue